// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  padding-top: 40px;
  background-color: black;
}

.no-errors {
  padding-top: 40px;
}
.no-errors p {
  text-align: center;
}

.errors-list {
  height: 100%;
  width: 100%;
  font-size: 10px;
  line-height: 10px;
  padding: 5px 0 80px 0;
  overflow-y: scroll;
}

.console-footer {
  background: black;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  display: flex;
  margin: 8px 0;
  padding-bottom: 20px;
}
.console-footer ion-button {
  height: 80%;
  width: 70%;
  margin: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/console-error/console-error.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;AACF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;AAAF;AAEE;EACE,WAAA;EACA,UAAA;EACA,WAAA;AAAJ","sourcesContent":[":host {\n  padding-top: 40px;\n  background-color: black;\n}\n\n.no-errors {\n  padding-top: 40px;\n\n  p {\n    text-align: center;\n  }\n}\n\n.errors-list {\n  height: 100%;\n  width: 100%;\n  font-size: 10px;\n  line-height: 10px;\n  padding: 5px 0 80px 0;\n  overflow-y: scroll;\n}\n\n.console-footer {\n  background: black;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  height: 60px;\n  display: flex;\n  margin: 8px 0;\n  padding-bottom: 20px;\n\n  ion-button {\n    height: 80%;\n    width: 70%;\n    margin: 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
